import { FALLBACK_LANG, LanguagesCode, supportedLanguages } from "@/config/languages";

export function getLanguage() {
  const currentLanguage = sessionStorage.getItem("i18nextLng");
  if (currentLanguage) {
    const isSupported = supportedLanguages.includes(currentLanguage as LanguagesCode);
    return isSupported ? currentLanguage : FALLBACK_LANG;
  } else {
    return FALLBACK_LANG;
  }
}
